__webpack_require__.p = "https://dsr-internal.staging.mindtickle.com/";